import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import { createCustomer, loginCustomer } from "../../store/actions/customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import Widget from "../../components/shared/Widget";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import { Link } from "react-router-dom";
import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";

import styles from "../../thema/style";
import "../../styles/ModernAuth.css";

class Login extends Component {
  state = {
    errors: [],
    email: "",
    password: "",
  };

  renderErrorMessage() {
    if (this.props.customer.errors.length > 0) {
      return (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ marginTop: 20 }}
        >
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.props.customer.errors.map((error, i) => (
                <li key={i}>{error.message}</li>
              ))}
            </ul>
          </p>
        </div>
      );
    }

    if (this.state.errors.length > 0) {
      return (
        <div
          className="alert alert-danger"
          role="alert"
          style={{ marginTop: 20 }}
        >
          <h4 className="alert-heading">Hata Meydana Geldi!</h4>
          <p>
            <ul>
              {this.state.errors.map((error, i) => (
                <li key={i}>{error}</li>
              ))}
            </ul>
          </p>
        </div>
      );
    } else {
      return null;
    }
  }

  validate = () => {
    const errors = [];
    if (!this.state.email) errors.push("E-Mail alanı boş bırakılamaz!");
    if (!this.state.password) errors.push("Şifreniz alanı boş bırakılamaz!");
    return errors;
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();
    var errors = this.validate();
    this.setState({ errors: errors });
    if (errors.length === 0) {
      this.props.loginCustomer({ ...this.state });
    }
  };

  render() {
    if (this.props.customer.customer) {
      return (
        <Redirect
          to={{
            pathname: "/hesabim",
            // state: { referrer: currentLocation }
          }}
        />
      );
    }
    return (
      <React.Fragment>
        <PageTitle title={"Giriş Yap"} />
        <div className="row">
          <div className={"col-md-6 offset-md-3"}>
            <div className={styles.loginBox}>
              <div className={"overlay-content"} />
              
              {/* Modern Auth Navigation */}
              <div className="auth-navigation">
                <Link to="/giris-yap" className="auth-nav-btn active">
                  <FontAwesomeIcon icon="sign-in-alt" />
                  <span>Giriş Yap</span>
                </Link>
                <Link to="/uye-ol" className="auth-nav-btn">
                  <FontAwesomeIcon icon="user-plus" />
                  <span>Kayıt Ol</span>
                </Link>
              </div>

              <div className={"tab-content"}>
                <h3>Giriş Yap</h3>
                <form onSubmit={this.onSubmit}>
                  <div className={"clearfix large_form"}>
                    <input
                      type="email"
                      name="email"
                      placeholder="E-mail Adresiniz"
                      defaultValue={this.state.email}
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      required
                    />
                  </div>
                  <div className={"clearfix large_form"}>
                    <input
                      type="password"
                      name="password"
                      placeholder="Şifreniz"
                      onChange={(e) => {
                        this.handleChange(e);
                      }}
                      required
                    />
                  </div>

                  <div className={"clearfix large_form text-right"}>
                    <Link className={"forgot-password"} to={"/sifremi-unuttum"}>
                      Şifremi Unuttum
                    </Link>
                  </div>
                  <div className={"clearfix large_form text-left"}>
                    <button type="submit">GİRİŞ YAP</button>
                    {this.renderErrorMessage()}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ customer }) => {
  return { customer };
};

const mapDispatchToProps = { createCustomer, loginCustomer };

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/routers/Login/index.js